import { render, staticRenderFns } from "./performance-scoring-sc.vue?vue&type=template&id=66fa57cc"
import script from "./performance-scoring-sc.vue?vue&type=script&lang=js"
export * from "./performance-scoring-sc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports